import { createStore } from 'vuex'
import axios from 'axios'
import { blogListConfig } from '../config'
const { buildCategoryFilter } = require('../config-parser.cjs')

export default createStore({
  state: {
    loaded: false,
    errors: [],
    entries: [],
    categories: blogListConfig.allowedCategories,
    currentPage: 1,
    itemsPerPage: blogListConfig.itemsPerPage,
    numberOfPages: 1,
    numberOfTotalArticles: 0,
    entriesFilter: blogListConfig.categoryUid,
    categoryHeadline: blogListConfig.categoryHeadline,
    disableSpecial: blogListConfig.disableSpecial,
    billboardPosition: blogListConfig.billboardPosition,
    locale: blogListConfig.locale
  },
  getters: {
    getEntriesParams: (state) => {
      const params = {
        currentPage: state.currentPage,
        itemsPerPage: state.itemsPerPage
      }
      const categoryFilter = buildCategoryFilter(state.entriesFilter, state.categories)
      if (categoryFilter) {
        params.category = {
          contains: categoryFilter
        }
      }
      return params
    },
    getCategoriesParams: (state) => {
      const params = {}

      if (state.categories.length) {
        params.uid = {
          in: state.categories
            .filter(category => category.uid !== state.entriesFilter)
            .map(category => category.uid)
            .join(',')
        }
      }
      return params
    }
  },
  mutations: {
    setLoaded (state, payload) {
      state.loaded = payload
    },
    setErrors (state, payload) {
      state.errors = payload
    },
    setEntries (state, payload) {
      state.entries = payload
    },
    addEntries (state, payload) {
      state.entries = [...state.entries,
        ...payload]
    },
    setCategories (state, payload) {
      state.categories = payload
    },
    resetCurrentPage (state) {
      state.currentPage = 1
    },
    increaseCurrentPage (state) {
      state.currentPage += 1
    },
    setNumberOfPages (state, payload) {
      state.numberOfPages = payload
    },
    setNumberOfTotalItems (state, payload) {
      state.numberOfTotalArticles = payload
    }
  },
  actions: {
    async getEntries ({
      commit,
      getters,
      state
    }) {
      commit('setLoaded', false)
      try {
        const response = await axios.get(blogListConfig.apiBase + 'blog-entries/', { params: getters.getEntriesParams })
        state.currentPage === 1
          ? commit('setEntries', response.data['blog-entries'])
          : commit('addEntries', response.data['blog-entries'])
        commit('setNumberOfPages', response.data.numberOfPages)
        commit('setNumberOfTotalItems', response.data.numberOfTotalItems)
        commit('setLoaded', true)
        return response
      } catch (e) {
        commit('setErrors', e, { root: true })
      }
    },
    async increasePage ({ commit }) {
      commit('increaseCurrentPage')
    }
  },
  modules: {}
})
